import BeelineModal from './beelineModal';

export default BeelineModal;
